<template>
  <div class="tab-container">
    Resupply
  </div>
</template>

<script >
import { getClimbingGroupsEquipmentItems } from '@/http'

export default {
  name: 'ClimbingGroupsCrewDetailResupply',
}
</script>

